require('select2');

$('.select-multiple').select2({
    placeholder: "Selecteer een optie",
});
